// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as EditComponent} from './Edit.svg';

import Icon, { TIconProps } from '../Icon';

export const IconEdit = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <EditComponent/>
  </Icon>
));
